module.exports = __webpack_public_path__ + "static/media/progressivo.e232644d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/recursos/progressivo.png
// module id = 1128
// module chunks = 0